import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Navbar } from 'react-bootstrap';
import Link from 'react-router/lib/Link';
import isEqual from 'lodash/isEqual';

class Header extends Component {
	shouldComponentUpdate = ({
		className,
		rootPath,
		logoPath,
		tagName,
		tagType,
	}) => {
		const lastProps = this.props;

		return (
			!isEqual(className, lastProps.className)
			|| !isEqual(rootPath, lastProps.rootPath)
			|| !isEqual(logoPath, lastProps.logoPath)
			|| !isEqual(tagName, lastProps.tagName)
			|| !isEqual(tagType, lastProps.tagType)
		);
	}

	render() {
		const {
			className,
			rootPath,
			logoPath,
			tagName,
			linkComponent : LinkComponent,
		} = this.props;

		return (
			<Navbar.Header className={className}>
				<div className="navbar-brand-container">
					<Navbar.Brand>
						<LinkComponent to={rootPath}>
							<img
								role="presentation"
								className="logo"
								src={logoPath}
								alt="RollKall Logo"
							/>
						</LinkComponent>
					</Navbar.Brand>
					<If condition={!!tagName}>
						<div className="tag-name">
							{ tagName }
						</div>
					</If>
				</div>
				<Navbar.Toggle />
			</Navbar.Header>
		);
	}
}

Header.propTypes = {
	linkComponent : PropTypes.func,
	rootPath      : PropTypes.string.isRequired,
	logoPath      : PropTypes.string.isRequired,
	className     : PropTypes.string,
	tagName       : PropTypes.string,
	tagType       : PropTypes.oneOf([
		'white',
		'orange',
	]),
};

Header.defaultProps = {
	linkComponent : Link,
	className     : '',
	tagName       : '',
	tagType       : 'white',
};

export default Header;
